import { env } from 'utils/env';

export const hosts = {
	lotsa: env.APP_LOTSA_HOST || 'my.lotsahelpinghands.com',
	mcc: env.APP_MCC_HOST || 'aflacmycancercircle.com',
	mcc2: env.APP_MCC2_HOST || 'mycancercircle.net',
	alsa: env.APP_ALSA_HOST || 'alsa.lotsahelpinghands.com',
	aicaf: env.APP_AICAF_HOST || 'aicafsacredcircle.com',
};
